import { createPortal } from 'react-dom';
import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material/styles';

const useStyles = makeStyles<Theme>(() => ({
  block: {
    height: '100%',
    left: '0',
    position: 'fixed',
    top: '0',
    width: '100%',
    zIndex: 10000,
  },
}));

export const Blocker = () => {
  const classes = useStyles();

  const node = <div className={classes.block} />;
  const root = document.getElementById('root');
  if (root) return <>{createPortal(node, root)}</>;
  else return null;
};
